module.exports = __webpack_public_path__ + "packs/media/images/Tamara_2-db16c7b555591ebcaf9379c5c6b681ae.jpg";